class SearchGlobal {
	static SELECTOR_CLASS_OFFSITE_BLOCK = '.search__offsite'
	static SELECTOR_CLASS_SUBMIT_BUTTON = '.search__offsite .search__submit'
	static SELECTOR_CLASS_SEARCH_CHECKBOX = '.searchajax__check'
	static SELECTOR_CLASS_SEARCH_RESULTS_CONTAINER = '.search__results'
	static SELECTOR_CLASS_CURRENT_BREADCRUMB = '.breadcrumbs__li--current em'
	static SELECTOR_CLASS_OFFSITE_SEARCH_COUNTER = '.search__offsite--count span'
	static SELECTOR_CLASS_MAIN_HEADING = '.search__offsite--title-copy h1'
	static SELECTOR_CLASS_SEARCH_AJAX_BUTTON = '.search__offsite--button'
	static SELECTOR_CLASS_LOADING_ICON = '.search__loading--icon'
	static SELECTOR_SEARCH_INPUT = '.search__searchform input[type="search"]'
	
	static AJAX_URL = 'wp-content/themes/JTF3/Lite/core/ajax_search.php'
	
	static URL_MAP = {
		'authorservices.taylorandfrancis.com': 'Author Services',
		'librarianresources.taylorandfrancis.com': 'Librarian Resources',
		'editorresources.taylorandfrancis.com': 'Editor Resources',
		'taylorandfrancis.com': 'Taylor & Francis',
		'This Site': 'This Site',
	}
	
	static CLASS_NAME_NO_RESULTS = 'col-md-6 col-12 search__noresults'
	static CLASS_NAME_SEARCH_ICON_SEARCH = 'fa-search'
	static CLASS_NAME_SEARCH_ICON_SPIN = 'fa-spin'
	static CLASS_NAME_SEARCH_ICON_LOADER = 'fa-loader'
	static CLASS_NAME_AJAX_SEARCH_ITEM = 'col-md-6 col-12 search__item'
	static CLASS_NAME_SEARCH_POST_TITLE = 'search__post-title'
	static CLASS_NAME_SEARCH_TERM_DETAILS = 'search__term--details'
	static CLASS_NAME_SEARCH_TERM_LOCATION = 'search__term--location'
	static CLASS_NAME_SEARCH_HIGHLIGHT = 'search-highlight'
	static CLASS_NAME_SECTION = 'section'
	
	static ATTR_DATA_TERM = 'data-term'
	static ATTR_DATA_SITE = 'data-site'
	static ATTR_DATA_RESULT = 'data-result'
	static ATTR_ARIA_HIDDEN = 'aria-hidden'
	static ATTR_ARIA_BUSY = 'aria-busy'
	static ATTR_DISABLED = 'disabled'
	
	static PROP_TRUE = 'true'
	static PROP_FALSE = 'false'
	
	static TEXT_NO_EXCERPT = 'no excerpt supplied'
	
	constructor() {
		this.allElements = []
		this.searchTargets = 0
		this.term = ''
		
		this.events()
	}
	
	replaceQueryParam( param, newval, search ) {
		const regex = new RegExp( '([?;&])' + param + '[^&;]*[;&]?' )
		const query = search.replace( regex, '$1' ).replace( /&$/, '' )
		
		return (query.length > 2 ? query + '&' : '?') + (newval ? param + '=' + newval : '')
	}
	
	stripHtml( string ) {
		return string.replace( /<\/?[^>]+(>|$)/g, '' )
	}
	
	setLoaderState( state ) {
		const ajaxButton = document.querySelector( SearchGlobal.SELECTOR_CLASS_SEARCH_AJAX_BUTTON )
		const loadingIcon = document.querySelector( SearchGlobal.SELECTOR_CLASS_LOADING_ICON )
		const resultsContainer = document.querySelector( SearchGlobal.SELECTOR_CLASS_SEARCH_RESULTS_CONTAINER )
		
		if ( state === true ) {
			if ( ajaxButton ) {
				const icon = ajaxButton.querySelector( 'i' )
				if ( icon ) {
					icon.classList.remove( SearchGlobal.CLASS_NAME_SEARCH_ICON_SEARCH )
					icon.classList.add( SearchGlobal.CLASS_NAME_SEARCH_ICON_LOADER, SearchGlobal.CLASS_NAME_SEARCH_ICON_SPIN )
				}
			}
			if ( loadingIcon ) {
				loadingIcon.setAttribute( SearchGlobal.ATTR_ARIA_HIDDEN, SearchGlobal.PROP_FALSE )
				loadingIcon.style.display = 'block'
			}
			if ( resultsContainer ) {
				resultsContainer.setAttribute( SearchGlobal.ATTR_ARIA_BUSY, SearchGlobal.PROP_TRUE )
			}
		} else {
			if ( ajaxButton ) {
				const icon = ajaxButton.querySelector( 'i' )
				if ( icon ) {
					icon.classList.remove( SearchGlobal.CLASS_NAME_SEARCH_ICON_LOADER, SearchGlobal.CLASS_NAME_SEARCH_ICON_SPIN )
					icon.classList.add( SearchGlobal.CLASS_NAME_SEARCH_ICON_SEARCH )
				}
			}
			if ( loadingIcon ) {
				loadingIcon.setAttribute( SearchGlobal.ATTR_ARIA_HIDDEN, SearchGlobal.PROP_TRUE )
				loadingIcon.style.display = 'none'
			}
			if ( resultsContainer ) {
				resultsContainer.setAttribute( SearchGlobal.ATTR_ARIA_BUSY, SearchGlobal.PROP_FALSE )
			}
		}
	}
	
	events() {
		document.addEventListener( 'click', ( event ) => {
			const button = event.target.closest( SearchGlobal.SELECTOR_CLASS_SEARCH_AJAX_BUTTON )
			if ( button ) {
				event.preventDefault()
				const searchTerm = button.getAttribute( SearchGlobal.ATTR_DATA_TERM )
				const parent = button.parentElement
				const input = parent ? parent.querySelector( 'input' ) : null
				const inputValue = input ? this.stripHtml( input.value ) : ''
				
				const searchInput = document.querySelector( SearchGlobal.SELECTOR_SEARCH_INPUT )
				if ( searchInput ) {
					searchInput.value = inputValue
				}
				
				this.setLoaderState( true )
				
				const resultsContainer = document.querySelector( SearchGlobal.SELECTOR_CLASS_SEARCH_RESULTS_CONTAINER )
				const mainHeading = document.querySelector( SearchGlobal.SELECTOR_CLASS_MAIN_HEADING )
				const breadcrumb = document.querySelector( SearchGlobal.SELECTOR_CLASS_CURRENT_BREADCRUMB )
				
				if ( resultsContainer ) {
					resultsContainer.innerHTML = ''
				}
				if ( mainHeading ) {
					mainHeading.innerHTML = 'Results for \'' + inputValue + '\''
				}
				if ( breadcrumb ) {
					breadcrumb.innerHTML = inputValue
				}
				
				button.setAttribute( SearchGlobal.ATTR_DATA_TERM, inputValue )
				
				const newUrl = this.replaceQueryParam( 's', inputValue, window.location.search )
				window.history.replaceState( {}, '', window.location.pathname + newUrl )
				document.title = 'Search Results for: \'' + inputValue + '\''
				
				this.allElements = []
				
				const checkboxes = document.querySelectorAll( SearchGlobal.SELECTOR_CLASS_SEARCH_CHECKBOX )
				for ( const checkbox of checkboxes ) {
					if ( checkbox.checked === true ) {
						this.searchTargets++
						this.getExternalPosts( checkbox.getAttribute( SearchGlobal.ATTR_DATA_SITE ), searchTerm )
					}
				}
			}
		} )
		
		const searchInput = document.querySelector( SearchGlobal.SELECTOR_SEARCH_INPUT )
		if ( searchInput ) {
			searchInput.addEventListener( 'input', ( event ) => {
				const inputString = this.stripHtml( event.target.value )
				event.target.value = inputString
				
				const ajaxButton = document.querySelector( SearchGlobal.SELECTOR_CLASS_SEARCH_AJAX_BUTTON )
				if ( ajaxButton ) {
					ajaxButton.setAttribute( SearchGlobal.ATTR_DATA_TERM, inputString )
				}
			} )
		}
		
		const checkboxes = document.querySelectorAll( SearchGlobal.SELECTOR_CLASS_SEARCH_CHECKBOX )
		for ( const checkbox of checkboxes ) {
			checkbox.addEventListener( 'change', () => {
				const checkedCheckboxes = document.querySelectorAll( SearchGlobal.SELECTOR_CLASS_SEARCH_CHECKBOX + ':checked' )
				const submitButton = document.querySelector( SearchGlobal.SELECTOR_CLASS_SUBMIT_BUTTON )
				const searchInput = document.querySelector( SearchGlobal.SELECTOR_SEARCH_INPUT )
				
				if ( checkedCheckboxes.length === 0 ) {
					if ( submitButton ) {
						submitButton.setAttribute( SearchGlobal.ATTR_DISABLED, SearchGlobal.PROP_TRUE )
					}
					if ( searchInput ) {
						searchInput.setAttribute( SearchGlobal.ATTR_DISABLED, SearchGlobal.PROP_TRUE )
					}
				} else {
					if ( submitButton ) {
						submitButton.removeAttribute( SearchGlobal.ATTR_DISABLED )
					}
					if ( searchInput ) {
						searchInput.removeAttribute( SearchGlobal.ATTR_DISABLED )
					}
				}
			} )
		}
	}
	
	orderResults() {
		if ( this.searchTargets > 0 ) {
			return
		}
		
		this.setLoaderState( false )
		
		const counter = document.querySelector( SearchGlobal.SELECTOR_CLASS_OFFSITE_SEARCH_COUNTER )
		if ( counter ) {
			counter.textContent = this.allElements.length
		}
		
		this.allElements.sort( ( a, b ) => {
			const aValue = parseInt( a.getAttribute( SearchGlobal.ATTR_DATA_RESULT ), 10 )
			const bValue = parseInt( b.getAttribute( SearchGlobal.ATTR_DATA_RESULT ), 10 )
			return aValue - bValue
		} )
		this.allElements.reverse()
		
		const resultsContainer = document.querySelector( SearchGlobal.SELECTOR_CLASS_SEARCH_RESULTS_CONTAINER )
		if ( resultsContainer ) {
			if ( this.allElements.length ) {
				for ( const element of this.allElements ) {
					resultsContainer.appendChild( element )
				}
			} else {
				const message = document.createElement( 'h3' )
				message.className = SearchGlobal.CLASS_NAME_NO_RESULTS
				message.textContent = 'No results found for \'' + this.term + '\''
				resultsContainer.appendChild( message )
			}
		}
		
		this.setLoaderState( false )
	}
	
	renderResults( json, term, target ) {
		const results = JSON.parse( json )
		
		this.term = this.stripHtml( term )
		
		for ( const result of results ) {
			const col = document.createElement( 'div' )
			col.className = SearchGlobal.CLASS_NAME_AJAX_SEARCH_ITEM
			col.setAttribute( SearchGlobal.ATTR_DATA_RESULT, result.relevance )
			
			const section = document.createElement( 'section' )
			section.className = SearchGlobal.CLASS_NAME_SECTION
			
			const h2 = document.createElement( 'h2' )
			h2.className = SearchGlobal.CLASS_NAME_SEARCH_POST_TITLE
			
			const p = document.createElement( 'p' )
			
			const anchor = document.createElement( 'a' )
			anchor.href = result.permalink
			
			const detailsContainer = document.createElement( 'div' )
			detailsContainer.className = SearchGlobal.CLASS_NAME_SEARCH_TERM_DETAILS
			
			const location = document.createElement( 'div' )
			location.className = SearchGlobal.CLASS_NAME_SEARCH_TERM_LOCATION
			location.textContent = 'Source: ' + (SearchGlobal.URL_MAP[ target ] || target)
			
			let title = result.title
			const regEx = new RegExp( term, 'ig' )
			let excerpt = result.excerpt
			
			if ( Array.isArray( excerpt ) ) {
				excerpt = excerpt[ 0 ]
			}
			
			title = title.replace( regEx, '<span class="' + SearchGlobal.CLASS_NAME_SEARCH_HIGHLIGHT + '">' + term + '</span>' )
			
			if ( excerpt !== '' ) {
				excerpt = excerpt.replace( regEx, '<span class="' + SearchGlobal.CLASS_NAME_SEARCH_HIGHLIGHT + '">' + term + '</span>' )
			} else {
				excerpt = SearchGlobal.TEXT_NO_EXCERPT
			}
			
			h2.innerHTML = title
			anchor.appendChild( h2 )
			p.innerHTML = excerpt
			detailsContainer.appendChild( location )
			
			section.appendChild( anchor )
			section.appendChild( p )
			section.appendChild( detailsContainer )
			col.appendChild( section )
			
			if ( result.relevance > 0 ) {
				this.allElements.push( col )
			}
		}
		
		this.searchTargets--
		
		this.orderResults()
	}
	
	getExternalPosts( target, term ) {
		target = target.replace( 'https://', '' )
		target = target.replace( 'http://', '' )
		
		const currentSite = window.location.hostname.replace( 'www.', '' )
		const normalizedTarget = target.replace( /^www\./, '' )
		const isCurrentSite = currentSite === normalizedTarget
		
		const params = new URLSearchParams( {
			search: encodeURIComponent( term ),
			url: 'https://' + target,
			api: 'search',
		} )
		
		fetch( SearchGlobal.AJAX_URL + '?' + params.toString(), {
			method: 'GET',
		} )
			.then( ( response ) => {
				if ( response.ok ) {
					return response.text()
				}
				throw new Error( 'Network response was not ok' )
			} )
			.then( ( data ) => {
				this.renderResults( data, term, isCurrentSite ? 'This Site' : target )
			} )
			.catch( () => {
				this.searchTargets--
				this.orderResults()
			} )
	}
}

export default function init() {
	const thisBlock = document.querySelectorAll( SearchGlobal.SELECTOR_CLASS_OFFSITE_BLOCK )
	
	if ( thisBlock.length > 0 ) {
		for ( const block of thisBlock ) {
			new SearchGlobal( block )
		}
	}
}
